"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function zil(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M6.76538 5.47686L15.1009 9.51411L17.2346 8.55261L8.93363 4.51611L6.76538 5.47686Z", fill: color, fillOpacity: 0.2 }),
        React.createElement("path", { d: "M15.1009 9.50436L17.2346 8.54361V10.6924L15.1009 11.6531V9.50436ZM15.1009 19.4674V12.7646L17.2346 11.7934V18.5066L15.1009 19.4674Z", fill: color, fillOpacity: 0.5 }),
        React.createElement("path", { d: "M6.76538 5.47913V7.65188L12.5351 10.4546L6.76538 13.3121V15.4541L15.1009 19.4839V17.3284L9.43988 14.5751L15.1009 11.6644V9.51563L6.76538 5.47913Z", fill: color }));
}
exports["default"] = zil;
//# sourceMappingURL=zil.js.map